"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _BeforeLogin = _interopRequireDefault(require("./containers/BeforeLogin"));
var _Login = _interopRequireDefault(require("./containers/Login"));
var _ForceChangePassword = _interopRequireDefault(require("./containers/ForceChangePassword"));
var _ForgotPassword = _interopRequireDefault(require("./containers/ForgotPassword"));
var _ForgotPasswordOtp = _interopRequireDefault(require("./containers/ForgotPasswordOtp"));
var _CreateProfile = _interopRequireDefault(require("./containers/CreateProfile"));
var _DispatcherLayout = _interopRequireDefault(require("./Layout/DispatcherLayout"));
var _HeaderLayout = _interopRequireDefault(require("./Layout/HeaderLayout"));
var _RoutePath = _interopRequireDefault(require("./RoutePath"));
var _NotificationPreferences = _interopRequireDefault(require("./containers/NotificationPreferences"));
var _AuthRoutes = _interopRequireDefault(require("./containers/AuthRoutes"));
var _EmailUpdate = _interopRequireDefault(require("./containers/EmailUpdate"));
var _reactToastify = require("react-toastify");
const DispatcherMainRoutes = () => {
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.basePath.path,
    element: /*#__PURE__*/_react.default.createElement(_BeforeLogin.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "".concat(_RoutePath.default.onboard.path, "/*"),
    element: /*#__PURE__*/_react.default.createElement(_HeaderLayout.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "".concat(_RoutePath.default.admin.path, "/*"),
    element: /*#__PURE__*/_react.default.createElement(_AuthRoutes.default, null, /*#__PURE__*/_react.default.createElement(_DispatcherLayout.default, null))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.login.path,
    element: /*#__PURE__*/_react.default.createElement(_Login.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.forceChangePassword.path,
    element: /*#__PURE__*/_react.default.createElement(_ForceChangePassword.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.forgotPassword.path,
    element: /*#__PURE__*/_react.default.createElement(_ForgotPassword.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.forgotPasswordOtp.path,
    element: /*#__PURE__*/_react.default.createElement(_ForgotPasswordOtp.default, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.createProfile.path,
    element: /*#__PURE__*/_react.default.createElement(_AuthRoutes.default, null, /*#__PURE__*/_react.default.createElement(_CreateProfile.default, null))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.NotificationPreferences.path,
    element: /*#__PURE__*/_react.default.createElement(_AuthRoutes.default, null, /*#__PURE__*/_react.default.createElement(_NotificationPreferences.default, null))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _RoutePath.default.emailUpdate.path,
    element: /*#__PURE__*/_react.default.createElement(_EmailUpdate.default, null)
  })), /*#__PURE__*/_react.default.createElement(_reactToastify.ToastContainer, {
    style: {
      zIndex: 10000
    },
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: true,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    transition: _reactToastify.Flip,
    closeButton: false,
    icon: false
  }));
};
var _default = exports.default = DispatcherMainRoutes;